import { render } from "./ProfessionalCertificate.vue?vue&type=template&id=a30a6a7e"
import script from "./ProfessionalCertificate.vue?vue&type=script&lang=js"
export * from "./ProfessionalCertificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__